import React from 'react';
import { GardenPlant } from '../../services/gardenService';
import './Garden.css';

interface PlantItemProps {
  plant: GardenPlant;
  position: { x: number; y: number };
  onClick: (e: React.MouseEvent, plant: GardenPlant) => void;
  isReadOnly?: boolean;
}

const PlantItem: React.FC<PlantItemProps> = ({ plant, position, onClick, isReadOnly = false }) => {
  const handleClick = (e: React.MouseEvent) => {
    onClick(e, plant);
  };

  // Format date for tooltip
  const formatDate = (dateStr: string | null | undefined): string => {
    if (!dateStr) return '';
    try {
      const date = new Date(dateStr);
      return date.toLocaleDateString('en-US', { 
        year: 'numeric', 
        month: 'short', 
        day: 'numeric' 
      });
    } catch {
      return dateStr;
    }
  };

  const dateTooltip = plant.plant_date ? formatDate(plant.plant_date) : '';
  const activityTooltip = plant.activity_score !== null && plant.activity_score !== undefined
    ? `Activity Score: ${plant.activity_score}`
    : '';

  const tooltip = dateTooltip && activityTooltip
    ? `${dateTooltip} - ${activityTooltip}`
    : dateTooltip || activityTooltip || '';

  return (
    <div
      className="garden-plant"
      style={{
        left: position.x,
        top: position.y,
        cursor: isReadOnly ? 'pointer' : 'default'
      }}
      onClick={handleClick}
      title={tooltip}
    >
      <span className="garden-plant-emoji">{plant.emoji || '🌱'}</span>
    </div>
  );
};

export default PlantItem;
